import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CipaFacilConfirmationConfig } from '@cipafacil/services/confirmation/confirmation.types';

@Component({
    selector     : 'cipafacil-confirmation-dialog',
    templateUrl  : './dialog.component.html',
    styles       : [
        /* language=SCSS */
        `
            .cipafacil-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-dialog-container {
                    padding: 0 !important;
                }
            }

            html.ios-cordova .cipafacil-confirmation-dialog-panel {
                // The close button is absolute, so wrapper padding cannot move it.
                .safe-area-top > .absolute {
                    top: var(--app-safe-area-top) !important;
                }

                @screen md {
                    // At desktop widths this dialog is centered, not full screen.
                    --app-safe-area-top: env(safe-area-inset-top, 0px);
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None
})
export class CipaFacilConfirmationDialogComponent implements OnInit
{
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: CipaFacilConfirmationConfig,
        public matDialogRef: MatDialogRef<CipaFacilConfirmationDialogComponent>
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
